import { inject, Injectable } from '@angular/core';
import { CustomPageMeta } from '@shared/models';
import { PageMetaService } from '@spartacus/core';
import { map, Observable } from 'rxjs';
import { SeoPageService } from './seo-page.service';

/**
 * Данный сервис используется для прокидывания метаданных хайбрисовых страниц.
 * Ведение страниц (листинговых, продуктовых) пока продолжаем в хайбрисе,
 * поэтому метаданные необходимо получать из хайбрисовых метарезолверов.
 *
 * Компоненты из нового редизайна (хлебные крошки, заголовок, сео текст) получают
 * метаданные из SeoPageService, поэтому необходимо в родительском компоненте
 * подменить SeoPageService на текущий.
 */
@Injectable({ providedIn: 'root' })
export class SeoHybrisPageService extends SeoPageService {
  private pageMetaService = inject(PageMetaService);

  getSeoPage(): Observable<CustomPageMeta | null> {
    return this.pageMetaService.getMeta();
  }

  isLoading(): Observable<boolean> {
    return this.pageMetaService.getMeta().pipe(
      map((meta: CustomPageMeta | null) => {
        return (meta as CustomPageMeta)?.loading || false;
      }),
    );
  }
}
